const toLower = (text: string): string => text.toLowerCase();

export default toLower;
